import { render, staticRenderFns } from "./VTag.vue?vue&type=template&id=2b32a0dc&scoped=true"
import script from "./VTag.vue?vue&type=script&lang=js"
export * from "./VTag.vue?vue&type=script&lang=js"
import style0 from "./VTag.vue?vue&type=style&index=0&id=2b32a0dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b32a0dc",
  null
  
)

export default component.exports